import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  useTheme,
} from '@mui/material';
import {
  Chat as ChatIcon,
  Search as SearchIcon,
  Bookmark as BookmarkIcon,
  History as HistoryIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const features = [
  {
    title: 'AI Chat Assistant',
    description: 'Get instant answers about Army regulations through our AI-powered chat interface.',
    icon: <ChatIcon sx={{ fontSize: 40 }} />,
    path: '/chat',
  },
  {
    title: 'Search Regulations',
    description: 'Search through Army regulations using keywords or phrases.',
    icon: <SearchIcon sx={{ fontSize: 40 }} />,
    path: '/search',
  },
  {
    title: 'Bookmarks',
    description: 'Access your saved regulations and frequently referenced sections.',
    icon: <BookmarkIcon sx={{ fontSize: 40 }} />,
    path: '/bookmarks',
  },
  {
    title: 'History',
    description: 'View your recent searches and AI interactions.',
    icon: <HistoryIcon sx={{ fontSize: 40 }} />,
    path: '/history',
  },
];

const Home: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography
          variant="h2"
          component="h1"
          sx={{
            color: theme.palette.army.textPrimary,
            fontWeight: 'bold',
            mb: 2,
          }}
        >
          Welcome to RegsGPT
        </Typography>
        <Typography
          variant="h5"
          sx={{
            color: theme.palette.army.textSecondary,
            maxWidth: '800px',
            mx: 'auto',
          }}
        >
          Your AI-powered assistant for navigating U.S. Army regulations
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {features.map((feature) => (
          <Grid item xs={12} sm={6} md={3} key={feature.title}>
            <Card
              sx={{
                height: '100%',
                bgcolor: theme.palette.army.main,
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                },
              }}
            >
              <CardActionArea
                onClick={() => navigate(feature.path)}
                sx={{ height: '100%' }}
              >
                <CardContent
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    height: '100%',
                  }}
                >
                  <Box
                    sx={{
                      color: theme.palette.army.accent,
                      mb: 2,
                    }}
                  >
                    {feature.icon}
                  </Box>
                  <Typography
                    gutterBottom
                    variant="h6"
                    component="h2"
                    sx={{ color: theme.palette.army.textPrimary }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: theme.palette.army.textSecondary }}
                  >
                    {feature.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Home; 